var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function getTaskContentWithProgress(orderedIds, nodeMap, progressMap, progressInfo, lanes, assignments) {
    return orderedIds.map(function (id) {
        var node = nodeMap[id];
        return [
            // here we override the type of body because we know it cannot be null,
            // as the orderedIds array only contains real steps,
            // not start or artificial-endings types.
            node.body,
            getNodeProgressInfo(id, node, progressMap[id], progressInfo),
            extractAssignmentForId(id, lanes, assignments),
        ];
    });
}
function getAssignee(assignment) {
    if (assignment.user != null) {
        return __assign(__assign({}, assignment.user), { content_type: 'user' });
    }
    if (assignment.team != null) {
        return __assign(__assign({}, assignment.team), { content_type: 'team' });
    }
    if (assignment.role != null) {
        return __assign(__assign({}, assignment.role), { content_type: 'role' });
    }
}
function extractAssignmentForId(step_id, lanes, assignments) {
    var step_in_lane = lanes[step_id];
    var step_assignments = [];
    for (var i = 0; i < assignments.length; i += 1) {
        var assignment = assignments[i];
        var assignee = getAssignee(assignment);
        if (assignee != null) {
            if (assignment.step_id === step_id) {
                step_assignments.push(assignee);
            }
            else if (step_in_lane != null &&
                assignment.lane != null &&
                assignment.lane.hashid === step_in_lane) {
                step_assignments.push(assignee);
            }
        }
    }
    return step_assignments;
}
function getNodeProgressInfo(id, node, nodeProgress, progressInfo) {
    var nodesAhead = progressInfo.nodesAhead, activeNodes = progressInfo.activeNodes, isSequenced = progressInfo.isSequenced, completedPath = progressInfo.completedPath;
    var isActive = isSequenced ? (activeNodes || new Set()).has(id) : true;
    var isCompleted = completedPath.indexOf(id) > -1;
    var isAhead = nodesAhead.has(id);
    var wasSkipped = !isActive && !isCompleted && !isAhead;
    var canToggle = isCompleted || isActive;
    return {
        isActive: isActive,
        isCompleted: isCompleted,
        isAhead: isAhead,
        canToggle: canToggle,
        wasSkipped: wasSkipped,
        completed: (nodeProgress === null || nodeProgress === void 0 ? void 0 : nodeProgress.completed) || null,
        fields: (nodeProgress === null || nodeProgress === void 0 ? void 0 : nodeProgress.fields) || {},
    };
}
